import { RoundedCheckCircleIcon } from "Components/Icons/RoundedCheckCircleIcon";
import { TimesIcon } from "Components/Icons/TimesIcon";
import React from "react";
import { Toast, ToastContainer } from "react-bootstrap";

interface UploadToastProps {
    show: boolean;
    onClose: () => void;
    title: string;
    message: string;
}

export const UploadToast = ({
    show,
    onClose,
    title,
    message,
}: UploadToastProps) => {
    return (
        <ToastContainer position="top-end" className="p-3">
            <Toast
                show={show}
                onClose={onClose}
                className="upload-toast"
                delay={5000}
                autohide
            >
                <Toast.Body>
                    <RoundedCheckCircleIcon className="checkIcon" />
                    <div className="text-container">
                        <span className="title-text">{title}</span>
                        <span className="message-text">{message}</span>
                    </div>
                    <TimesIcon
                        className="closeIcon"
                        onClick={onClose}
                    />
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};
